import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Alert } from 'reactstrap';
import { QRCodeSVG } from 'qrcode.react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt, faDownload, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import Flex from '../common/Flex';

const VisitorQRCodeModal = ({ isOpen, toggle, visitorData }) => {
    if (!visitorData) return null;

    const appUrl = import.meta.env.VITE_URL || window.location.origin;
    const visitUrl = `${appUrl.replace(/\/$/, '')}/v/${visitorData.access_token}`;

    const downloadQR = () => {
        const svg = document.getElementById('visitor-qr');
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
            const width = 450;
            const height = 650;
            canvas.width = width;
            canvas.height = height;

            // Background
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, width, height);

            // Purple Header
            ctx.fillStyle = '#950ec3';
            ctx.fillRect(0, 0, width, 80);

            // Homelan Text
            ctx.fillStyle = '#ffffff';
            ctx.font = 'bold 32px sans-serif';
            ctx.textAlign = 'center';
            ctx.fillText('HOMELAN', width / 2, 50);

            // Subtitle
            ctx.fillStyle = '#344050';
            ctx.font = 'bold 22px sans-serif';
            ctx.fillText('PASE DE ENTRADA', width / 2, 140);

            // QR Code (centered)
            const qrSize = 300;
            ctx.drawImage(img, (width - qrSize) / 2, 180, qrSize, qrSize);

            // Visitor Info
            ctx.fillStyle = '#6c757d';
            ctx.font = '14px sans-serif';
            ctx.fillText('VISITANTE:', width / 2, 510);

            const fullName = visitorData.firstname
                ? `${visitorData.firstname} ${visitorData.lastname}`
                : `${visitorData.people?.firstname} ${visitorData.people?.lastname}`;

            ctx.fillStyle = '#344050';
            ctx.font = 'bold 20px sans-serif';
            ctx.fillText(fullName, width / 2, 540);

            // Property Info
            ctx.fillStyle = '#6c757d';
            ctx.font = '14px sans-serif';
            ctx.fillText('DESTINO:', width / 2, 580);

            const propertyName = visitorData.property?.property ||
                visitorData.property?.authCredential?.username ||
                visitorData.property?.auth_credential?.username ||
                "Residencia";
            const condoName = visitorData.property?.condominium?.name || "Homelan App";
            ctx.fillStyle = '#344050';
            ctx.font = 'bold 18px sans-serif';
            ctx.fillText(`${propertyName} - ${condoName}`, width / 2, 610);

            const pngFile = canvas.toDataURL('image/png');
            const downloadLink = document.createElement('a');
            downloadLink.download = `Pase_Homelan_${visitorData.access_token.substring(0, 8)}.png`;
            downloadLink.href = pngFile;
            downloadLink.click();
        };
        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
    };

    const shareViaWhatsApp = () => {
        const condonimiumName = visitorData.property?.condominium?.name || "tu condominio";
        const text = `Hola! Aquí tienes tu pase de entrada para ${condonimiumName}. Por favor muéstralo en la garita: ${visitUrl}`;
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="sm">
            <ModalHeader toggle={toggle} className="bg-success text-white">
                <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                Registro Exitoso
            </ModalHeader>
            <ModalBody className="text-center p-4">
                <h5 className="mb-3">¡Todo listo!</h5>
                <Alert color="warning" className="fs--2 text-left mb-3">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
                    <strong>Advertencia:</strong> Indique al visitante que NO abra ni comparta este link innecesariamente. Si el vigilante lo escanea y llega al límite de entradas ({visitorData.limit_entries || 1}), el pase quedará invalidado inmediatamente.
                </Alert>
                <p className="text-muted fs--1">
                    Comparte este código QR con tu visitante para que el vigilante lo valide al llegar.
                </p>

                <div className="bg-white p-3 border rounded d-inline-block mb-3">
                    <QRCodeSVG
                        id="visitor-qr"
                        value={visitUrl}
                        size={200}
                        level="H"
                        includeMargin={true}
                    />
                </div>

                <Row className="mt-3">
                    <Col>
                        <Button color="primary" block onClick={shareViaWhatsApp}>
                            <FontAwesomeIcon icon={faShareAlt} className="mr-2" />
                            WhatsApp
                        </Button>
                    </Col>
                    <Col>
                        <Button color="light" block onClick={downloadQR}>
                            <FontAwesomeIcon icon={faDownload} className="mr-2" />
                            Descargar
                        </Button>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default VisitorQRCodeModal;
